
export const provinces = {
    "Eastern Cape": 1,
    "Gauteng": 2,
    "Kopano": 3,
    "KwaZulu-Natal": 4,    
    "North West": 6,
    "Western Cape": 7,
    "Mpumalanga": 8,
    "Limpopo": 9
  };
  
  
 export const local_market = {
    "Jhb CBD": 1,
    "Jhb Central": 2,
    "Jhb North": 3,
    "Jhb South": 4,
    "Soweto": 5,
    "Buffalo City & Surrounds": 101,
    "Mthatha & Surrounds":102,
    "Nelson Mandela Bay": 103,
    "Sarah Baartman": 104,
    "Ekurhuleni East & Ekurhuleni Central": 201,
    "OLD Fourways & Midrand": 202,
    "OLD Joburg South": 204,
    "Ekurhuleni South": 205,
    "Mogale North & Mogale South": 206,
    "Ekurhuleni North": 207,
    "Tshwane East & Tshwane Central":208,
    "Tshwane North": 209,
    "Tshwane South": 210,
    "OLD Sandton & Rosebank": 211,
    "OLD Soweto": 212,
    "Vaal": 213,
    "Central Free State": 301,
    "Eastern Free State": 302,
    "Northern Cape": 303,
    "Dolphin Coast": 401,
    "Drakensburg": 402,
    "Ethekwini": 403,
    "Hibiscus Coast": 404,
    "Msunduzi": 405,
    "Zululand": 406,
    "Highveld": 501,
    "Lowveld":502,
    "Limpopo North":601,
    "Limpopo South": 602,
    "Klerksdorp": 701,
    "Rustenburg": 702,
    "Boland West Coast": 801,
    "Cape Peninsula Winelands": 802,
    "City & South": 803, 
    "Garden Route Karoo": 804, 
    "OLD Overberg Winelands": 805,
    "Tygerberg": 806
  }

  export const province_market_map = {
    "Eastern Cape": {
      'value': 1,
      'local_markets': ["Buffalo City & Surrounds", "Mthatha & Surrounds", "Nelson Mandela Bay", "Sarah Baartman" ]
    },
    "Gauteng": {
      'value':2,
      'local_markets':["Jhb CBD",  "Jhb Central", "Jhb North", "Jhb South", "Soweto", "Ekurhuleni East & Ekurhuleni Central", "Ekurhuleni South",  "Mogale North & Mogale South",  "Ekurhuleni North", "Tshwane East & Tshwane Central", "Tshwane North", "Tshwane South", "Vaal"]
    },
    "Kopano": {
      'value': 3,
      'local_markets': ["Central Free State", "Eastern Free State", "Northern Cape"]
    },
    "KwaZulu-Natal": {
      'value': 4,
      'local_markets':[ "Dolphin Coast", "Drakensburg", "Ethekwini", "Hibiscus Coast", "Msunduzi", "Zululand"]
    },    
    "North West": {
      'value': 6,
      'local_markets': ["Klerksdorp", "Rustenburg" ]
    },
    "Western Cape": {
      'value': 7,
      'local_markets': [ "Boland West Coast", "Cape Peninsula Winelands", "City & South", "Garden Route Karoo", "Tygerberg"]
    },
    "Mpumalanga": {
      'value': 8,
      'local_markets': ["Highveld", "Lowveld"]
    },
    "Limpopo": {
      'value': 9,
      'local_markets':["Limpopo North", "Limpopo South"]
    }
  }

export const segments = {
  "Total Youth, Mass & Middle Market": [1,2],
  "Total Private": [3,4]
}